<template>
     <div style="width:350px;margin-left:auto;margin-right:auto">
    <div style="width:100%;text-align:center;margin-top:15px;height:50px" class="headline">Check Status</div>

         <v-text-field
                type="number"
                v-model="number"
                style="margin:0 auto;height:60px"
                label="Enter Complaint ID"
                solo
          ></v-text-field>
        <div style="width:100%;float:left">
            <v-btn color="primary" style="width:100%;margin:0 auto;" @click="submit">Submit</v-btn>
        </div>
     </div>
</template>

<script>
export default {    
    data(){
        return{
            number:'',
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        },
        clear(){
            return this.$store.getters.clear;
        },
    },
    watch:{
        clear(value){                        
                this.cleardata();
        }
    },
    methods:{
        cleardata(){
            let vm = this;
            vm.operator =""
            vm.number ="";
        },
        submit(){
            let vm = this;
            if(vm.user.length==0) return vm.$store.dispatch("notify",{vm:vm,message:"Authentication Required!",type:"warn"})
            if(vm.number=="")return vm.$store.dispatch("notify",{vm:vm,message:"Recharge Number Required",type:"error"})
            if(vm.remark=="")return vm.$store.dispatch("notify",{vm:vm,message:"Recharge Amount Required",type:"error"})
            let params = "?Mob="+vm.user.phone+"&message=comstatus+"+vm.number+"+"+vm.user.pin+"&source=ANDROID"            
            let data = {
                "Complaint ID":vm.number,
            }
            vm.$parent.data = data;
            vm.$parent.params = params.toString();
            vm.$parent.preview = true;
        },

    },
    mounted(){
        let vm = this;
    }
}
</script>

<style>
.leftdiv{
    width: 300px;
    float: left;
    margin-bottom:10px;
}
.rightdiv{
    margin-top:10px;
    float: left;
    height: 100px;
}
</style>
